import type {PageRouteConfig} from '@router';

import {type HeaderDataPayload} from '@ds/types';
import {useRouteBuildContext} from '@router';
import CouponDetails from 'modules/Services/PromotionCenter/Coupon/Details/CouponDetails';
import {useCallback} from 'react';

const CouponDetailsPageElement: React.FC = () => {
  const {updateHeaderData} = useRouteBuildContext();
  const handleHeaderData = useCallback(
    (headerData: HeaderDataPayload) => {
      updateHeaderData('couponDetails', headerData);
    },
    [updateHeaderData]
  );

  return <CouponDetails headerData={handleHeaderData} />;
};

export function createPromotionCenterCouponDetailsRoute(): PageRouteConfig {
  return {
    element: <CouponDetailsPageElement />,
    layout: {
      title: 'جزئیات کوپن',
      hasNavigate: false,
      hasHeader: true,
      hasBack: true,
      hasLeftIcon: false,
      link: -1,
      headerDataKey: 'couponDetails'
    },
    initialHeaderData: {
      couponDetails: {icon: '', iconTitle: '', action: null, title: '', iconClassName: null}
    }
  };
}
